module.exports = __webpack_public_path__ + "img/inventory-export.4e2e730d.png";